// Immer-compatible draft mutation helper.
//
// Clones plain objects and arrays recursively. Non-plain values (Symbols,
// functions, class instances, null) are kept by reference — matching immer's
// behavior, which only proxies plain objects and arrays and shares everything
// else structurally. structuredClone is too strict here: it throws on those
// types, while immer's Proxy approach naturally avoids cloning them.

function safeClone<T>(value: T): T {
  if (typeof value !== "object" || value === null) return value;
  if (Array.isArray(value)) return (value as unknown[]).map(safeClone) as unknown as T;
  if (Object.getPrototypeOf(value) !== Object.prototype) return value;
  const result: Record<string, unknown> = {};
  for (const key of Object.keys(value as Record<string, unknown>)) {
    result[key] = safeClone((value as Record<string, unknown>)[key]);
  }
  return result as unknown as T;
}

export function produce<T>(base: T, recipe: (draft: T) => T | void): T {
  const draft = safeClone(base);
  const result = recipe(draft);
  if (result !== undefined) return result;
  return draft;
}
